<div class="row" soho-personalize>
  <div class="column full">

    <div class="field">
      <div class="div-spacer">
        <span class="command">{{ 'ToggleMenu' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftK' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'CommandShiftK' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'Save' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftS' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'CommandShiftS' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'PreviousRecord' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftLeftArrow' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'CommandShiftLeftArrow' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'NextRecord' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftRightArrow' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'CommandShiftRightArrow' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'FieldDefine' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftF6' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'FnF6' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'Refresh' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftF5' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'FnF5' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'Open' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlAltO' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'CommandAltO' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'FieldSelect' | translate }}</span><span class="keys">{{ 'DownArrow' | translate }}</span>
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'FieldOptions' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlShiftF7' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'FnF7' | translate }}</span>
        }
      </div>
      <div class="div-spacer">
        <span class="command">{{ 'OpenFullScreen' | translate }}</span>
        @if (!isMac) {
          <span class="keys">{{ 'CtrlClickOrCtrlEnter' | translate }}</span>
        }
        @if (isMac) {
          <span class="keys">{{ 'CmdClickOrCmdEnter' | translate }}</span>
        }
      </div>
    </div>
  </div>
</div>
